'use client';

import { FC } from 'react';
import Icon from '~/components/icon';
import { YMGoal, useMetrika } from '~/providers/ya-metrica';
import phoneHref from '~/utils/phone-href';

import styles from './styles.module.css';

interface Props {
  phone: string | null;
}

const Phone: FC<Props> = ({ phone }) => {
  const { captureGoal } = useMetrika();

  const onPhoneClick = () => {
    captureGoal(YMGoal.NUMBER_CLICK);
  };

  return (
    <a onClick={onPhoneClick} href={phoneHref(phone)} target="_blank" rel="noreferrer" className={styles.phoneLink}>
      <span>{phone}</span>
      <Icon name="call" className={styles.icon} />
    </a>
  );
};

export default Phone;
